import { Component, OnInit } from '@angular/core';
import { EmailService } from 'src/app/services/email/email.service';


@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {

  constructor(
    private emailService: EmailService
  ) { }

  ngOnInit() {
  }



}
